module.exports = __webpack_public_path__ + "img/dashboard.cdf9b07b.svg";